export default __webpack_public_path__ + "static/beatrice-fd9f39f9d2feff2964a6b9766cafdea0.png";